export class TransactionalMutator {
    constructor(mutators) {
        this.mutators = mutators;
    }
    mutate(context, typeRef, model) {
        let result, newModel = model;
        for (let mutator of this.mutators) {
            [newModel, result] = mutator.mutate(context, typeRef, newModel);
            if (result.isInvalid) {
                return [newModel, result];
            }
        }
        return [newModel, result];
    }
}
//# sourceMappingURL=TransactionalMutator.js.map